import _ from 'lodash';
import React, {Component, Fragment} from 'react';
import {MOUSE_CATCHER_ID, KNOB_DIRECTIONS, VIEW_MODES} from 'crazyEditor/core/constants/editorConstants';
import {connect} from 'react-redux';
import {
  updateElementSizeByDirection,
  updateElementPosition,
  updateElementPositionByDelta,
  dragCompleteAndUpdateElementsPosition,
  dragCompleteAndUpdateElementsSize,
} from 'crazyEditor/redux/modules/element/actions/elementLayoutActions';
import {deleteElement, duplicateDesktopElement} from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import {hideMobileElement} from 'crazyEditor/redux/modules/element/actions/mobileElementActions';
import {undoActionElement, redoActionElement} from 'crazyEditor/redux/modules/element/actions/generalActions';
import {
  updateMousePositionByDelta,
  setEditingTextElementId,
  setMouseDragStartPosition,
  setMousePosition,
  setHoveredElementId,
  setIsResizingPageElement,
  clearStageState,
  setSelectedElementIds,
  clearHoveredElementId,
  toggleSelectedElementId,
} from 'crazyEditor/redux/modules/stage/stage';
import {
  getSelectedElements,
  getAllVisibleElementsForView,
  getElementsForView,
  isMultiSelect,
  getPreviousActionViewMode,
  getNextActionViewMode,
} from 'crazyEditor/redux/modules/element/elementSelectors';
import * as MouseCatcherUtils from './MouseCatcherUtils';
import HoverBox from './HoverBox/HoverBox';
import EditBox from './EditBox/EditBox';
import Lasso from './Lasso/Lasso';
import FloatingActionButtons from './FloatingActionButtons/FloatingActionButtons';
import FloatingInfoBar from './FloatingInfoBar/FloatingInfoBar';
import {HeightPageResize, WidthPageResize} from './PageResize/index';
import styles from './MouseCatcherStyles';
import {getElementDefinitionProps, isElementEditable} from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {
  isStaticElement,
  getPageElement,
  BACKGROUND_ELEMENT_ID,
  PAGE_ELEMENT_ID,
} from 'crazyEditor/core/elements/utils/elementStaticUtils';
import ContextMenu from './ContextMenu/ContextMenu';
import {pushScope, keymaster} from 'shared/helpers/keymasterHelper';
import {
  SHIFT_KEY_MOVE_ELEMENT_BY_DELTA_X,
  MOVE_ELEMENT_BY_DELTA_X,
  PAGE_RESIZE_SCROLL_SPACING,
  HEIGHT_PAGE_RESIZE_BUTTON_SPACING_FROM_PAGE_ELEMENT,
  WIDTH_PAGE_RESIZE_BUTTON_SPACING_FROM_PAGE_ELEMENT,
  KEY_SCOPE_NAME,
} from './MouseCatcherConstants';
import {editDesktopElement} from 'crazyEditor/core/elements/utils/elementAddUpdateUtils';
import {isChildIdBelongsToParentId, isChildElementId} from 'crazyEditor/core/elements/utils/elementFilterUtils';
import {ADDED_ELEMENT_ANIMATION_DURATION} from 'crazyEditor/core/constants/editorConstants';
import {getParentIdFromChildId} from 'crazyEditor/redux/modules/element/helpers/elementChildrenHelpers';
import {templateService} from 'shared/helpers/TemplateService';
import CopyPasteListener from './CopyPasteListener/CopyPasteListener';
import {setViewModeInEditor} from 'crazyEditor/core/utils/stageUtils';

@connect(
  state => ({
    selectedElementIds: state.stage.selectedElementIds,
    viewMode: state.editor.viewMode,
    previousActionViewMode: getPreviousActionViewMode(state),
    nextActionViewMode: getNextActionViewMode(state),
    hoveredElementId: state.stage.hoveredElementId,
    isDraggingElement: state.stage.isDraggingElement,
    isResizingElement: state.stage.isResizingElement,
    editingElementId: state.stage.editingElementId,
    isResizingPageElement: state.stage.isResizingPageElement,
    pageElementResizeDirection: state.stage.pageElementResizeDirection,
    draggingDirection: state.stage.draggingDirection,
    selectedElements: getSelectedElements(state),
    isMultiSelect: isMultiSelect(state),
    stageLayout: state.stage.layout,
    allElements: getAllVisibleElementsForView(state),
    elements: getElementsForView(state),
  }),
  {
    updateElementSizeByDirection,
    updateElementPosition,
    updateElementPositionByDelta,
    setSelectedElementIds,
    hideMobileElement,
    setMouseDragStartPosition,
    setHoveredElementId,
    setIsResizingPageElement,
    clearStageState,
    clearHoveredElementId,
    deleteElement,
    toggleSelectedElementId,
    undoActionElement,
    redoActionElement,
    setEditingTextElementId,
    setMousePosition,
    dragCompleteAndUpdateElementsPosition,
    dragCompleteAndUpdateElementsSize,
    updateMousePositionByDelta,
    duplicateDesktopElement,
  }
)
export default class MouseCatcher extends Component {
  constructor(props) {
    super(props);

    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.hideSelectedMobileElement = this.hideSelectedMobileElement.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onContextMenu = this.onContextMenu.bind(this);
    this.state = {
      startDragStartPageX: 0,
      startDragStartPageY: 0,
      dragStartPageX: 0,
      dragStartPageY: 0,
      contextMenuPosition: null,
      showLasso: false,
      waitingForNewAddedElement: false,
    };
  }

  componentDidMount() {
    keymaster(
      'ctrl, left, right, up, down, esc, delete, backspace, shift, shift+left, shift+right, shift+up, shift+down, ctrl+a, command+a, ' +
        'ctrl+z, command+z, ctrl+y, shift+ctrl+z, command+y, shift+command+z, ctrl+s, command+s, ctrl+d, command+d',
      KEY_SCOPE_NAME,
      this.handleKeyDown
    );
    pushScope(KEY_SCOPE_NAME);
    document.addEventListener('scroll', this.onScroll);
    document.addEventListener('mouseup', this.onMouseUp);

    this.lastScrollPosition = window.scrollY || window.pageYOffset;
  }

  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps.selectedElements, '[0].added')) {
      this.setState({waitingForNewAddedElement: true});
      window.setTimeout(() => {
        this.setState({waitingForNewAddedElement: false});
      }, ADDED_ELEMENT_ANIMATION_DURATION + 200);
    } else {
      this.setState({waitingForNewAddedElement: false});
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (!this.state.waitingForNewAddedElement && nextState.waitingForNewAddedElement) {
      this.additionalStyle = {opacity: 0, transitionDuration: '0ms'};
    } else if (this.state.waitingForNewAddedElement && !nextState.waitingForNewAddedElement) {
      this.additionalStyle = {opacity: 1};
    }
  }

  componentWillUnmount() {
    keymaster.deleteScope(KEY_SCOPE_NAME);
    document.removeEventListener('mouseup', this.onMouseUp);
    document.removeEventListener('scroll', this.onScroll);
  }

  onMouseDown(event) {
    const {
      setSelectedElementIds,
      allElements,
      setMouseDragStartPosition,
      selectedElementIds,
      toggleSelectedElementId,
      isMobileView,
    } = this.props;
    let elementId;
    if (event.button !== 0) {
      return;
    }

    const mousePosition = {x: event.pageX, y: event.pageY};
    const state = {
      startDragStartPageX: mousePosition.x,
      startDragStartPageY: mousePosition.y,
      dragStartPageX: mousePosition.x,
      dragStartPageY: mousePosition.y,
    };

    let element = MouseCatcherUtils.getElementUnderMousePosition(
      allElements,
      mousePosition,
      isMobileView,
      selectedElementIds[0]
    );
    if (element) {
      elementId = this.getNormalizedElementId(element.id, selectedElementIds[0]);
      if (event.shiftKey || event.ctrlKey) {
        toggleSelectedElementId(elementId);
        if (selectedElementIds.length === 1 && selectedElementIds[0] === elementId) {
          this.selectDefaultComponent();
        }
      } else if (selectedElementIds.indexOf(elementId) === -1) {
        setSelectedElementIds(elementId);
      }
    } else {
      this.selectDefaultComponent();
    }

    // for dragging purpose, we need the locked flag of the parent.
    if (element && element.parentId) {
      element = allElements[element.parentId];
    }
    if (!_.get(element, 'locked')) {
      setMouseDragStartPosition(mousePosition);
      this.setState(state);
    }
  }

  onContextMenu(event) {
    const clientMousePosition = {x: event.clientX, y: event.clientY};
    const pageMousePosition = {x: event.pageX, y: event.pageY};
    const stateUpdate = {contextMenuPosition: clientMousePosition};
    const {setSelectedElementIds, allElements, selectedElementIds, isMobileView} = this.props;
    const element = MouseCatcherUtils.getElementUnderMousePosition(allElements, pageMousePosition, isMobileView);
    if (element && selectedElementIds[0] !== element.id) {
      setSelectedElementIds(element.id);
    }
    if (element && [BACKGROUND_ELEMENT_ID, PAGE_ELEMENT_ID].indexOf(element.id) === -1) {
      window.document.addEventListener('click', this.deferredCloseContextMenu); // needs to be deffered so the context menu will finish processing the onclick event
      window.document.addEventListener('contextmenu', this.closeContextMenu);
      _.defer(() => {
        this.setState(stateUpdate);
      });
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }

  onMouseMove(event) {
    const {
      setMousePosition,
      selectedElementIds,
      isDraggingElement,
      isResizingElement,
      isResizingPageElement,
    } = this.props;
    const {contextMenuPosition} = this.state;
    if (contextMenuPosition) {
      return;
    }
    const mousePosition = {
      x: event.pageX,
      y: event.pageY,
    };

    if (!isDraggingElement && !isResizingElement && !isResizingPageElement) {
      this.setHoveredElement(mousePosition);
      return;
    }

    if (this.state.dragStartPageX !== 0 && this.state.dragStartPageY !== 0) {
      if (isResizingElement) {
        setMousePosition(mousePosition);
      } else if (isResizingPageElement) {
        this.handlePageElementResize(mousePosition);
      } else if (this.shouldShowLasso(selectedElementIds)) {
        this.showLasso();
      } else {
        setMousePosition(mousePosition);
      }
    }
    this.setState({
      dragStartPageX: mousePosition.x,
      dragStartPageY: mousePosition.y,
    });
  }

  onMouseUp(event) {
    const {isDraggingElement, isResizingElement, isResizingPageElement, editingElementId} = this.props;
    if (!(isDraggingElement || isResizingElement || isResizingPageElement || editingElementId)) {
      return;
    }
    if (
      MouseCatcherUtils.isCkeditorToolbar(event.target) ||
      _.get(this, 'editBoxRef.textEditBoxRef.focusLocked', false)
    ) {
      return;
    }
    const {clearStageState} = this.props;
    if (isDraggingElement) {
      this.handleDragComplete();
    } else if (isResizingElement) {
      this.handleResizeComplete();
    }
    clearStageState();
    this.setState({
      startDragStartPageX: 0,
      startDragStartPageY: 0,
      dragStartPageX: 0,
      dragStartPageY: 0,
      showLasso: false,
    });
  }

  onScroll = () => {
    const {isDraggingElement, updateMousePositionByDelta} = this.props;
    const {contextMenuPosition} = this.state;
    if (contextMenuPosition) {
      this.closeContextMenu();
    }
    if (isDraggingElement) {
      const deltaY = (window.scrollY || window.pageYOffset) - this.lastScrollPosition;
      let {dragStartPageY} = this.state;
      updateMousePositionByDelta({deltaY});
      dragStartPageY += deltaY;
      this.setState({
        dragStartPageY,
      });
    }
    this.lastScrollPosition = window.scrollY || window.pageYOffset;
  };

  getNormalizedElementId(elementId, parentId) {
    if (elementId !== parentId && isChildElementId(elementId) && !isChildIdBelongsToParentId(elementId, parentId)) {
      return getParentIdFromChildId(elementId);
    }
    return elementId;
  }

  setHoveredElement(mousePosition) {
    const {
      allElements,
      isMultiSelect,
      setHoveredElementId,
      clearHoveredElementId,
      selectedElementIds,
      hoveredElementId,
      isDraggingElement,
      isResizingElement,
      isResizingPageElement,
      isMobileView,
    } = this.props;

    const element = MouseCatcherUtils.getElementUnderMousePosition(
      allElements,
      mousePosition,
      isMobileView,
      selectedElementIds[0],
      true,
      hoveredElementId
    );
    if (element) {
      const elementId = this.getNormalizedElementId(element.id, selectedElementIds[0]);
      if ([BACKGROUND_ELEMENT_ID, PAGE_ELEMENT_ID].indexOf(elementId) !== -1) {
        if (hoveredElementId) {
          clearHoveredElementId();
        }
      } else {
        const elementIsNotEqualToSelectedElement = elementId !== selectedElementIds[0];
        const elementIsNotEqualToHoveredElement = hoveredElementId !== elementId;
        const isElementHoverable = getElementDefinitionProps(element).hoverable;
        const isElementNotInMultiSelect =
          !isMultiSelect || (isMultiSelect && selectedElementIds.indexOf(element.id) === -1);
        const isNotDraggingOrResizing = !isDraggingElement && !isResizingElement && !isResizingPageElement;

        if (
          elementIsNotEqualToSelectedElement &&
          elementIsNotEqualToHoveredElement &&
          isElementHoverable &&
          isElementNotInMultiSelect &&
          isNotDraggingOrResizing
        ) {
          setHoveredElementId(elementId);
        }
      }
    } else if (hoveredElementId) {
      clearHoveredElementId();
    }
  }

  selectDefaultComponent() {
    const {isDesktopView, setSelectedElementIds} = this.props;
    if (isDesktopView) {
      setSelectedElementIds(BACKGROUND_ELEMENT_ID);
    } else {
      setSelectedElementIds(PAGE_ELEMENT_ID);
    }
  }

  hideSelectedMobileElement() {
    const {selectedElementIds, setSelectedElementIds, clearHoveredElementId, hideMobileElement} = this.props;
    if (selectedElementIds) {
      setSelectedElementIds(PAGE_ELEMENT_ID);
      clearHoveredElementId();
      hideMobileElement(selectedElementIds);
    }
  }

  deleteElement() {
    const {selectedElementIds, deleteElement} = this.props;
    if (selectedElementIds) {
      deleteElement(selectedElementIds);
    }
  }

  shouldShowLasso(selectedElementIds) {
    return [BACKGROUND_ELEMENT_ID, PAGE_ELEMENT_ID].indexOf(selectedElementIds[0]) !== -1;
  }

  showLasso() {
    this.setState({
      showLasso: true,
    });
  }

  handleDragComplete = () => {
    const {dragCompleteAndUpdateElementsPosition, viewMode, selectedElementIds} = this.props;
    const dragDelta = MouseCatcherUtils.getDragDeltaFromStore();
    if (dragDelta) {
      dragCompleteAndUpdateElementsPosition(viewMode, selectedElementIds, dragDelta.deltaX, dragDelta.deltaY);
    }
  };

  handleResizeComplete(keepAspectRatio) {
    const {draggingDirection, viewMode, dragCompleteAndUpdateElementsSize, selectedElementIds} = this.props;
    const dragDelta = MouseCatcherUtils.getDragDeltaFromStore();
    if ([PAGE_ELEMENT_ID, BACKGROUND_ELEMENT_ID].indexOf(selectedElementIds[0]) === -1) {
      dragCompleteAndUpdateElementsSize(
        viewMode,
        selectedElementIds,
        dragDelta.deltaX,
        dragDelta.deltaY,
        draggingDirection,
        keepAspectRatio
      );
    }
  }

  handlePageElementResize(mousePosition) {
    const {pageElementResizeDirection, updateElementSizeByDirection, viewMode} = this.props;
    const deltaX = mousePosition.x - this.state.dragStartPageX;
    const deltaY = mousePosition.y - this.state.dragStartPageY;
    switch (pageElementResizeDirection) {
      case KNOB_DIRECTIONS.BOTTOM_MIDDLE:
        updateElementSizeByDirection(viewMode, [PAGE_ELEMENT_ID], null, deltaY, KNOB_DIRECTIONS.BOTTOM_MIDDLE);
        break;
      case KNOB_DIRECTIONS.MIDDLE_RIGHT:
        updateElementSizeByDirection(viewMode, [PAGE_ELEMENT_ID], deltaX * 2, null, KNOB_DIRECTIONS.MIDDLE_RIGHT);
        break;
      default:
        throw new Error('Unknown direction for page resize');
    }
  }

  handleKeyDown(event, keyMasterEvent) {
    const {
      selectedElements,
      setSelectedElementIds,
      elements,
      undoActionElement,
      redoActionElement,
      clearStageState,
      duplicateDesktopElement,
      clearHoveredElementId,
    } = this.props;
    if (selectedElements.locked) {
      return;
    }
    const {
      isMobileView,
      selectedElementIds,
      updateElementPositionByDelta,
      viewMode,
      previousActionViewMode,
      nextActionViewMode,
    } = this.props;
    const movePx = event.shiftKey ? SHIFT_KEY_MOVE_ELEMENT_BY_DELTA_X : MOVE_ELEMENT_BY_DELTA_X;
    if (selectedElements.length) {
      const elementDefinitionProps = getElementDefinitionProps(selectedElements[0]);
      switch (keyMasterEvent.key) {
        case 'ctrl+a':
        case 'command+a':
          if (_.size(elements) > 0) {
            setSelectedElementIds(_.map(_.filter(elements, element => !element.parentId), element => element.id));
          }
          break;
        case 'delete':
        case 'backspace':
          if (!isStaticElement(selectedElements[0].id)) {
            if (isMobileView) {
              this.hideSelectedMobileElement();
            } else {
              this.deleteElement();
            }
          }
          break;
        case 'right':
        case 'shift+right':
          if (elementDefinitionProps.draggable.x) {
            updateElementPositionByDelta(viewMode, selectedElementIds, movePx, 0);
          }
          break;
        case 'left':
        case 'shift+left':
          if (elementDefinitionProps.draggable.x) {
            updateElementPositionByDelta(viewMode, selectedElementIds, -movePx, 0);
          }
          break;
        case 'up':
        case 'shift+up':
          if (elementDefinitionProps.draggable.y) {
            updateElementPositionByDelta(viewMode, selectedElementIds, 0, -movePx);
          }
          break;
        case 'down':
        case 'shift+down':
          if (elementDefinitionProps.draggable.y) {
            updateElementPositionByDelta(viewMode, selectedElementIds, 0, movePx);
          }
          break;
        case 'esc':
          setSelectedElementIds(PAGE_ELEMENT_ID);
          break;
        case 'ctrl+z':
        case 'command+z':
          if (previousActionViewMode && viewMode !== previousActionViewMode) {
            setViewModeInEditor(previousActionViewMode, previousActionViewMode === VIEW_MODES.MOBILE);
          } else {
            undoActionElement();
          }
          break;
        case 'ctrl+y':
        case 'command+y':
        case 'shift+ctrl+z':
        case 'shift+command+z':
          if (nextActionViewMode && viewMode !== nextActionViewMode) {
            setViewModeInEditor(nextActionViewMode, nextActionViewMode === VIEW_MODES.MOBILE);
          } else {
            redoActionElement();
          }
          break;
        case 'ctrl+s':
        case 'command+s':
          templateService.saveCurrentTemplate();
          break;
        case 'ctrl+d':
        case 'command+d':
          duplicateDesktopElement(selectedElementIds);
          break;

        default:
          return;
      }

      event.stopPropagation();
      event.preventDefault();
    }
  }

  deferredCloseContextMenu = () => {
    _.defer(this.closeContextMenu);
  };

  closeContextMenu = () => {
    window.document.removeEventListener('click', this.deferredCloseContextMenu);
    window.document.removeEventListener('contextmenu', this.closeContextMenu);
    this.setState({contextMenuPosition: null});
  };

  movedByAtleast1Pixel(dragDeltaX, dragDeltaY) {
    return Math.abs(dragDeltaX) >= 1 || Math.abs(dragDeltaY) >= 1;
  }

  additionalStyle = {};

  render() {
    const {
      elements,
      selectedElements,
      isDesktopView,
      isMobileView,
      stageLayout,
      isDraggingElement,
      isResizingElement,
    } = this.props;
    const {
      startDragStartPageX,
      startDragStartPageY,
      dragStartPageX,
      dragStartPageY,
      showLasso,
      contextMenuPosition,
    } = this.state;
    const dragDeltaX = dragStartPageX - startDragStartPageX;
    const dragDeltaY = dragStartPageY - startDragStartPageY;
    return (
      <div
        id={MOUSE_CATCHER_ID}
        style={{
          minHeight: stageLayout.height + PAGE_RESIZE_SCROLL_SPACING,
          ...styles.mouseCatcherContainer,
          ...this.additionalStyle,
        }}
        onMouseMove={this.onMouseMove}
        onMouseDown={this.onMouseDown}
        onContextMenu={this.onContextMenu}
        onClick={this.onClick}
      >
        <EditBox
          ref={ref => {
            if (ref) this.editBoxRef = ref;
          }}
        />
        <HoverBox />
        {!isMobileView && !this.movedByAtleast1Pixel(dragDeltaX, dragDeltaY) && <FloatingActionButtons />}
        {this.movedByAtleast1Pixel(dragDeltaX, dragDeltaY) && (
          <FloatingInfoBar isResizingElement={isResizingElement} isDraggingElement={isDraggingElement} />
        )}
        <HeightPageResize
          stageLayout={stageLayout}
          spacingFromPageElement={HEIGHT_PAGE_RESIZE_BUTTON_SPACING_FROM_PAGE_ELEMENT}
        />
        {isDesktopView && (
          <WidthPageResize
            stageLayout={stageLayout}
            spacingFromPageElement={WIDTH_PAGE_RESIZE_BUTTON_SPACING_FROM_PAGE_ELEMENT}
          />
        )}
        {showLasso && (
          <Lasso
            elements={elements}
            x={startDragStartPageX}
            y={startDragStartPageY}
            width={dragDeltaX}
            height={dragDeltaY}
            stageLayoutTop={stageLayout.top}
          />
        )}
        {!isDraggingElement && (
          <Fragment>
            <ContextMenu
              position={contextMenuPosition}
              onRequestClose={this.closeContextMenu}
              onEdit={() => editDesktopElement(selectedElements[0])}
              copyPasteListenerRef={this.refs.copyPasteListener ? this.refs.copyPasteListener : {}}
            />
            <CopyPasteListener ref="copyPasteListener" />
          </Fragment>
        )}
      </div>
    );
  }
}
